import React from "react";
// import img from "../../blog1.jpg";
import { FaGithub, FaLinkedin } from "react-icons/fa";
const Intro = () => {
	return (
		<div className="intro">
			<h1 className="firstname">Satendra</h1>
			<h1 className="lastname">Sharma</h1>
			<p className="littledetail">
				4th year student at <span className="college">GCECT</span>
			</p>
			<hr />
			<span>
				<a
					href="https://github.com/satendrassharma"
					target="_blank"
					rel="noopener noreferrer"
				>
					<FaGithub size="40px" style={{ marginRight: "10px" }} />
				</a>
				<a
					href="https://in.linkedin.com/in/satendra-sharma-56718b132?trk=people-guest_profile-result-card_result-card_full-click"
					target="_blank"
					rel="noopener noreferrer"
				>
					<FaLinkedin size="40px" />
				</a>
			</span>
		</div>
	);
};

export default Intro;
